import CreateTicketFormPage from './CreateTicketFormPage';

export default CreateTicketFormPage;
